import React from "react"
import { Layout, ILayout } from "./layout"
import { Flex, Box, Text } from "@chakra-ui/react"
import { Logo } from "../primitives"

export interface IAuthLayout extends ILayout {
  title: React.ReactNode
  desc: React.ReactNode
}

export const AuthLayout = ({ children, title, desc }: IAuthLayout) => {
  return (
    <Flex
      width="100vw"
      height="100vh"
      align="center"
      justify="center"
      background="page.bg"
    >
      <Box
        mx="auto"
        width="100%"
        maxWidth={["100%", "450px", "450px", "450px"]}
        borderRadius="md"
        boxShadow="md"
        border="1px solid"
        borderColor="gray.200"
        p={6}
        background="white"
      >
        <Flex
          align="center"
          justify="center"
          p={4}
          height="30px"
          textAlign="center"
        >
          <Box
            fontSize="4xl"
            fontFamily="heading"
            fontWeight={900}
            color="red"
            letterSpacing="6px"
          >
            <Logo />
          </Box>
        </Flex>

        <Box my={6}>
          <Text fontSize="xl" fontFamily="heading">
            {title}
          </Text>
          <Text color="text.regular">{desc}</Text>
        </Box>

        {children}
      </Box>
    </Flex>
  )
}
